import { Flow_Parameter__String__Input } from '~/graphql/types';
import { StringParameterValue } from '~/scenes/Automation/Flows/Actions/Base/types.flow';

import { PARAMETER_VALUE_TYPE } from '../constants';
import asStringPrimitiveParameterValueInput from './asStringPrimitiveParameterValueInput';

export default (
  parameterValue: StringParameterValue,
): Flow_Parameter__String__Input => {
  switch (parameterValue.type) {
    case PARAMETER_VALUE_TYPE.STRING_PRIMITIVE:
      return asStringPrimitiveParameterValueInput(parameterValue);
    case PARAMETER_VALUE_TYPE.STRING_POINTER:
      if (
        parameterValue.variable == null ||
        parameterValue.variable.field == null
      ) {
        throw new Error(
          `Validation should have caught that the parameterValue ${JSON.stringify(
            parameterValue,
            null,
            2,
          )} has no field`,
        );
      }

      return {
        String: {
          Pointer: {
            variable: parameterValue.variable.name,
            field: parameterValue.variable.field.name,
          },
        },
      };
    default:
      throw new Error(
        `Field value input conversion cannot handle (${JSON.stringify(
          parameterValue,
          null,
          2,
        )})`,
      );
  }
};
